import * as Yup from "yup";

export const getEditPatientSchema = (isQCStudy)=>Yup.object({
  patientName: Yup.string()
    .min(3, "Patient name must be at least 3 characters")
    .max(100, "Patient name must be 100 characters or less")
    .matches(/^[^<>]*$/, 'Patient name cannot contain HTML tags')
    .matches(/^[^=+\-@].*$/, 'Patient name cannot start with =, +, - or @')
    .required("Patient name cannot be blank"),
  age: Yup.string()
      .nullable()
      .test(
        'age-validation',
        'Age must be valid',
        function (value) {
          if (isQCStudy) {
            if (!value || value.trim() === '' || value === '-') return true;
          }
          const regex = /(^[0-9]{1,3}[DWMYdwmy]$)|(^[0-9]{1,3}$)/;
          return regex.test(value);
        }
      ),
  patientId: Yup.string()
    .min(1, "Patient id must be at least 1 characters")
    .max(50, "Patient id must be 50 characters or less")
    .matches(/^[^<>]*$/, 'Patient id cannot contain HTML tags')
    .matches(/^[^=+\-@].*$/, 'Patient id cannot start with =, +, - or @')
    .required("Patient id cannot be blank"),
  studyDescription: Yup.string()
    .max(255, "Study description must be at most 255 characters")
    .matches(/^[^<>]*$/, 'Study description cannot contain HTML tags')
    .matches(/^[^=+\-@].*$/, 'Study description cannot start with =, +, - or @')
    .required("Study description can't be empty"),
  referringPhysician: Yup.string()
    .min(3, "Referring physician name must be atleast 3 characters")
    .max(100, "Referring physician name must be 100 characters or less")
    .nullable()
    .matches(/^[\x20-\x7E]*$/, 'Referring physician contains invalid character'),
});
